import React, { useEffect } from 'react';
import { useAwaitControl } from 'react-redux-await-control';

import { Pendencies } from '~/screens/Contract/components/Tabs/Pendencies/Pendencies';
import { getDetails } from '~/store/contracts/actions';
import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type CardPendenciesViewProps = {
  contractId: string;
  backofficeContractId: number | string | null | undefined;
  onBack: () => void;
};

export function CardPendenciesView({ contractId, backofficeContractId, onBack }: CardPendenciesViewProps) {
  const detailsControl = useAwaitControl(getDetails);

  useEffect(() => {
    if (backofficeContractId) {
      detailsControl.start({ id: backofficeContractId });
    }
  }, [backofficeContractId]);

  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      {!!backofficeContractId && <Pendencies />}
    </div>
  );
}
